import React, { useState, useEffect, useRef } from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
// import Loader from "../../biztran_controls/Loader";


const CreateAccount = (props) => {
    const classes = useStyles();
    const [Mode, setMode] = useState('')
    //// debugger;
    const [AccountCode, setAccountCode] = useState(props.AccountMainData === undefined || props.AccountMainData[0].AccountCode === null ? "" : props.AccountMainData[0].AccountCode);
    // console.log(response.AccountCode);
    const [ReferenceCode, setReferenceCode] = useState(props.AccountMainData === undefined || props.AccountMainData[0].ReferenceCode === null ? "" : props.AccountMainData[0].ReferenceCode);
    // const [AccCode,setAccCode]= useState('');
    // const [PFChargesPer, setPFChargesPer] = useState(0);
    const [DisableGSTIN, setDisableGSTIN] = useState(false);
    const [DisableCIN, setDisableCIN] = useState(false);
    const [AccName, setAccName] = useState(props.AccountMainData === undefined || props.AccountMainData[0].AccountName === null ? "" : props.AccountMainData[0].AccountName);
    const [AccTypeID, setAccTypeID] = useState(props.AccountMainData === undefined || props.AccountMainData[0].AccountTypeID === null ? "" : props.AccountMainData[0].AccountTypeID);
    const [AccGroupID, setAccGroupID] = useState(props.AccountMainData === undefined || props.AccountMainData[0].AccountGroupID === null ? "" : props.AccountMainData[0].AccountGroupID);
    const [IndustryID, setIndustryID] = useState(props.AccountMainData === undefined || props.AccountMainData[0].IndustryID === null ? "" : props.AccountMainData[0].IndustryID);
    const [CurrencyID, setCurrencyID] = useState(props.AccountMainData === undefined || props.AccountMainData[0].CurrencyID === null ? '5c4e647e-6dee-4c46-be09-b169bb1e46be' : props.AccountMainData[0].CurrencyID);
    const [WebSite, setWebSite] = useState(props.AccountMainData === undefined || props.AccountMainData[0].WebSite === null ? "" : props.AccountMainData[0].WebSite);
    const [PhoneNo, setPhoneNo] = useState(props.AccountMainData === undefined || props.AccountMainData[0].Phone === null ? '' : props.AccountMainData[0].Phone);
    const [NoOfEmp, setNoOfEmp] = useState('');
    const [Description, setDescription] = useState(props.AccountMainData === undefined || props.AccountMainData[0].Description === null ? "" : props.AccountMainData[0].Description);
    const [BillAddress1, setBillAddress1] = useState(props.AccountMainData === undefined || props.AccountMainData[0].BillAddress1 === null ? "" : props.AccountMainData[0].BillAddress1);
    const [BillAddress2, setBillAddress2] = useState(props.AccountMainData === undefined || props.AccountMainData[0].BillAddress2 === null ? "" : props.AccountMainData[0].BillAddress2);
    const [BillCity, setBillCity] = useState(props.AccountMainData == undefined || props.AccountMainData[0].BillCity === null ? "" : props.AccountMainData[0].BillCity);
    const [BillCountryID, setBillCountryID] = useState(props.AccountMainData === undefined || props.AccountMainData[0].BillCountryID === null ? "" : props.AccountMainData[0].BillCountryID);
    const [BillStateID, setBillStateID] = useState(props.AccountMainData === undefined || props.AccountMainData[0].BillStateID === null ? "" : props.AccountMainData[0].BillStateID);
    const [BillPINCode, setBillPINCode] = useState(props.AccountMainData === undefined || props.AccountMainData[0].BillPINCode === null ? "" : props.AccountMainData[0].BillPINCode);
    const [ShipAddress1, setShipAddress1] = useState(props.AccountMainData === undefined || props.AccountMainData[0].ShipAddress1 === null ? "" : props.AccountMainData[0].ShipAddress1);
    const [ShipAddress2, setShipAddress2] = useState(props.AccountMainData === undefined || props.AccountMainData[0].ShipAddress2 === null ? "" : props.AccountMainData[0].ShipAddress2);
    const [ShipCity, setShipCity] = useState(props.AccountMainData === undefined || props.AccountMainData[0].ShipCity === null ? "" : props.AccountMainData[0].ShipCity);
    const [ShipCountryID, setShipCountryID] = useState(props.AccountMainData === undefined || props.AccountMainData[0].ShipCountryID === null ? "" : props.AccountMainData[0].ShipCountryID);
    const [ShipStateID, setShipStateID] = useState(props.AccountMainData === undefined || props.AccountMainData[0].ShipStateID === null ? "" : props.AccountMainData[0].ShipStateID);
    const [ShipPINCode, setShipPINCode] = useState(props.AccountMainData === undefined || props.AccountMainData[0].ShipPINCode === null ? "" : props.AccountMainData[0].ShipPINCode);
    const [GSTIN, setGSTIN] = useState(props.AccountMainData === undefined || props.AccountMainData[0].GSTIN === null ? "" : props.AccountMainData[0].GSTIN);
    const [CIN, setCIN] = useState(props.AccountMainData === undefined || props.AccountMainData[0].CIN === null ? "" : props.AccountMainData[0].CIN);
    const [response, fetchData] = UseFetchData();
    const [isChecked, setIsChecked] = useState(false);
    // const [isDoubleChecked, setIsDoubleChecked] = useState(false);
    const [AccTypecmb, setAccTypecmb] = useState([]);
    const [AccGroupcmb, setAccGroupcmb] = useState([]);
    const [Industrycmb, setIndustrycmb] = useState([]);
    const [Currencycmb, setCurrencycmb] = useState([]);
    const [BillCountrycmb, setBillCountrycmb] = useState([]);
    const [BillStatecmb, setBillStatecmb] = useState([]);
    const [ShipCountrycmb, setShipCountrycmb] = useState([]);
    const [ShipStatecmb, setShipStatecmb] = useState([]);
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);
    const [loading, setLoading] = useState(true);
    const [DisableSaveBtn, setDisableSaveBtn] = useState(false);



    const validationSchema = Yup.object({
        AccName: Yup.string().required('Required!'),
        AccTypeID: Yup.string().required('Required!'),
        IndustryID: Yup.string().required('Required!'),
        BillAddress1: Yup.string().required('Required!'),
        BillCountryID: Yup.string().required('Required!'),
        BillCity: Yup.string().required('Required!'),
        CurrencyID: Yup.string().required('Required!'),

    });

    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e) => {
        // setCursor(e.target.selectionStart);
        onChange && onChange(e);
    };



    const onSubmit = values => {
        setMode('Insert');
        var UpdatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        // var mob = +91;
        //// debugger;
        bodyFormData.append("AccountID", props.AccountID);
        bodyFormData.append("AccountTypeID", values.AccTypeID);
        bodyFormData.append("AccountCode", values.AccountCode);
        bodyFormData.append("ReferenceCode", values.ReferenceCode);
        // bodyFormData.append("AccCode",values.AccCode);
        bodyFormData.append("AccountName", values.AccName);
        bodyFormData.append("AccountGroupID", values.AccGroupID);
        bodyFormData.append("IndustryID", values.IndustryID);
        bodyFormData.append("CurrencyID", values.CurrencyID);
        bodyFormData.append("WebSite", values.WebSite);
        bodyFormData.append("Phone", values.PhoneNo);
        bodyFormData.append("NoOfEmployees", values.NoOfEmp);
        bodyFormData.append("Description", values.Description);
        bodyFormData.append("BillAddress1", values.BillAddress1);
        bodyFormData.append("ShipAddress1", values.ShipAddress1);
        bodyFormData.append("BillAddress2", values.BillAddress2);
        bodyFormData.append("ShipAddress2", values.ShipAddress2);
        bodyFormData.append("BillCity", values.BillCity);
        bodyFormData.append("BillStateID", values.BillStateID);
        bodyFormData.append("ShipCity", values.ShipCity);
        bodyFormData.append("ShipStateID", values.ShipStateID);
        bodyFormData.append("BillPINCode", values.BillPINCode);
        bodyFormData.append("BillCountryID", values.BillCountryID);
        bodyFormData.append("ShipPINCode", values.ShipPINCode);
        bodyFormData.append("ShipCountryID", values.ShipCountryID);
        bodyFormData.append("GSTIN", values.GSTIN);
        bodyFormData.append("CIN", values.CIN);
        bodyFormData.append("UpdatedByID", UpdatedByID);
        setLoading(true);
        setDisableSaveBtn(true);
        fetchData("Account/Save", bodyFormData);
    }


    useEffect(() => {
        //debugger;
        if (isChecked) {
            setShipAddress1(BillAddress1);
            setShipAddress2(BillAddress2);
            setShipCountryID(BillCountryID);
            setShipStateID(BillStateID);
            setShipCity(BillCity);
            setShipPINCode(BillPINCode);
        }
        else if (props.AccountID !== "" && ShipAddress1 !== "") {
            setShipAddress1(BillAddress1);
            setShipAddress2(BillAddress2);
            setShipCountryID(BillCountryID);
            setShipStateID(BillStateID);
            setShipCity(BillCity);
            setShipPINCode(BillPINCode);
        }
        else {
            setShipAddress1("");
            setShipAddress2("");
            setShipCountryID("");
            setShipStateID("");
            setShipCity("");
            setShipPINCode("");
        }
    }, [isChecked]);

    useEffect(() => {
        //debugger;
        if (sessionStorage.UID == '101B316C-5D92-4066-82AB-35741EE773F8' || sessionStorage.UserType == "Admin") {

            setDisableGSTIN(false);
            setDisableCIN(false);
        }
        else {
            if (CurrencyID != '5c4e647e-6dee-4c46-be09-b169bb1e46be') {
                setDisableGSTIN(true);
                setDisableCIN(true);
            }
            else {
                setDisableGSTIN(false);
                setDisableCIN(false);
            }
        }

    });


    useEffect(() => {
        if (response.Response === undefined) {
            setLoading(false);
        }
        else if (response.Response === true) {
            // debugger;
            props.setOpen(false);
            props.PopulateData();
            setLoading(false);
            alert(response.Message);
            setDisableSaveBtn(true);

        }
        else if (response.Response === false) {
            if (response.Message.includes('Already') === true) {
                alert(response.Message);
                setLoading(false);
                setDisableSaveBtn(false);

            }
            else {
                alert('Failed.');
                setLoading(false);
                setDisableSaveBtn(false);
            }
        }
    }, [response]);

    useEffect(() => {
        if (props.AccountID !== '') {
            setMode('Update');
        }
        else {
            setMode('Insert');
        }
        if (response.length > 0 && Mode === 'Update') {
            setAccountCode(response[0].AccountCode);
            setReferenceCode(response[0].ReferenceCode === null ? "" : response[0].ReferenceCode);
            setAccGroupID(response[0].AccountGroupID === null ? "" : response[0].AccountGroupID);
            setAccName(response[0].AccountName);
            setAccTypeID(response[0].AccountTypeID === null ? "" : response[0].AccountTypeID);
            setBillAddress1(response[0].BillAddress1 === null ? "" : response[0].BillAddress1);
            setBillAddress2(response[0].BillAddress2 === null ? "" : response[0].BillAddress2);
            setBillCity(response[0].BillCity === null ? "" : response[0].BillCity);
            setBillCountryID(response[0].BillCountryID === null ? "" : response[0].BillCountryID);
            setBillPINCode(response[0].BillPINCode);
            setCurrencyID(response[0].CurrencyID === null ? "" : response[0].CurrencyID);
            setDescription(response[0].Description === null ? "" : response[0].Description);
            setIndustryID(response[0].IndustryID === null ? "" : response[0].IndustryID);
            setGSTIN(response[0].GSTIN === null ? "" : response[0].GSTIN);
            setCIN(response[0].CIN === null ? "" : response[0].CIN);
            setPhoneNo(response[0].Phone === null ? "" : response[0].Phone);
            setShipAddress1(response[0].ShipAddress1 === null ? "" : response[0].ShipAddress1);
            setShipAddress2(response[0].ShipAddress2 === null ? "" : response[0].ShipAddress2);
            setShipCity(response[0].ShipCity === null ? "" : response[0].ShipCity);
            setShipCountryID(response[0].ShipCountryID === null ? "" : response[0].ShipCountryID);
            setShipPINCode(response[0].ShipPINCode);
            setWebSite(response[0].WebSite === null ? "" : response[0].WebSite);
            setBillStateID(response[0].BillStateID === null ? "" : response[0].BillStateID);
            setShipStateID(response[0].ShipStateID === null ? "" : response[0].ShipStateID);
        }
    }, [response]);


    const AccountTypeData = (options) => {
        if (options !== undefined) {
            let AccountType = options.map((data) =>
                <option
                    key={data.AccountType}
                    value={data.AccountTypeID}
                >
                    {data.AccountType}
                </option>
            );
            setAccTypecmb(AccountType)
        }
    }

    const AccountGroupData = (options) => {
        //// debugger;
        if (options !== undefined) {
            let AccountGroup = options.map((data) =>
                <option
                    key={data.AccountGroup}
                    value={data.AccountGroupID}
                >
                    {data.AccountGroup}
                </option>
            );
            setAccGroupcmb(AccountGroup)
        }
    }

    const IndustryData = (options) => {
        if (options !== undefined) {
            let Industry = options.map((data) =>
                <option
                    key={data.Industry}
                    value={data.IndustryID}
                >
                    {data.Industry}
                </option>
            );
            setIndustrycmb(Industry)
        }
    }

    const CurrencyData = (options) => {
        if (options !== undefined) {
            let Currency = options.map((data) =>
                <option
                    key={data.Currency}
                    value={data.CurrencyID}
                >
                    {data.Currency}
                </option>
            );
            setCurrencycmb(Currency)
        }
    }

    // const CountryData = (options) => {
    //    // debugger;
    //     if (options !== undefined) {
    //         let Country = options.map((data) =>
    //             <option
    //                 key={data.Country}
    //                 value={data.CountryID}
    //             >
    //                 {data.Country}
    //             </option>
    //         );
    //         setBillCountrycmb(Country)
    //         setShipCountrycmb(Country)
    //     }
    // }

    const CountryData = React.useCallback((options) => {
        if (options !== undefined) {
            let Country = options.map((data) => (
                <option key={data.Country} value={data.CountryID}>
                    {data.Country}
                </option>
            ));
            setBillCountrycmb(Country);
            setShipCountrycmb(Country);
        }
    }, []);

    const BillStatecmbData = (CID) => {
        // debugger;
        var id = "";
        if (CID !== "") {
            id = CID;
        } else if (BillCountryID !== "") {
            id = BillCountryID;
        } else {
            id = "";
        }
        let options = ComboDataResponse["State"];
        if (options !== undefined) {
            if (id !== "") {
                let State = options
                    .filter((option) => option.CountryID === id)
                    .map((data) => (
                        <option key={data.StateName} value={data.StateID}>
                            {data.StateName}
                        </option>
                    ));
                setBillStatecmb(State);
            }

            else {
                let State = options.map((data) => (
                    <option key={data.StateName} value={data.StateID}>
                        {data.StateName}
                    </option>
                ));
                setBillStatecmb(State);
            }
        }
    };


    const ShipStatecmbData = (CID) => {
        // debugger;
        var id = "";
        if (CID !== "") {
            id = CID;
        } else if (BillCountryID !== "") {
            id = BillCountryID;
        } else {
            id = "";
        }
        let options = ComboDataResponse["State"];
        if (options !== undefined) {
            if (id !== "") {
                let State = options
                    .filter((option) => option.CountryID === id)
                    .map((data) => (
                        <option key={data.StateName} value={data.StateID}>
                            {data.StateName}
                        </option>
                    ));
                setShipStatecmb(State);
            }
            else {
                let State = options.map((data) => (
                    <option key={data.StateName} value={data.StateID}>
                        {data.StateName}
                    </option>
                ));
                setShipStatecmb(State);
            }
        }
    };

    // const BillStatecmbData = (CID) => {
    //    // debugger;
    //     let options = ComboDataResponse["State"]
    //     if (options !== undefined) {
    //         if (CID !== "") {
    //             let State = options.filter(option => option.CountryID === CID).map((data) =>
    //                 <option
    //                     key={data.StateName}
    //                     value={data.StateID}
    //                 >
    //                     {data.StateName}
    //                 </option>
    //             );
    //             setBillStatecmb(State)

    //         }
    //         else {
    //             let State = options.map((data) =>
    //                 <option
    //                     key={data.StateName}
    //                     value={data.StateID}
    //                 >
    //                     {data.StateName}
    //                 </option>
    //             );
    //             setBillStatecmb(State)
    //         }

    //     }
    // }

    // const ShipStatecmbData = (CID) => {
    //     let options = ComboDataResponse["State"]
    //     if (options !== undefined) {
    //         if (CID !== "") {
    //             let State = options.filter(option => option.CountryID === CID).map((data) =>
    //                 <option
    //                     key={data.StateName}
    //                     value={data.StateID}
    //                 >
    //                     {data.StateName}
    //                 </option>
    //             );
    //             setShipStatecmb(State)
    //         }
    //         else {
    //             let State = options.map((data) =>
    //                 <option
    //                     key={data.StateName}
    //                     value={data.StateID}
    //                 >
    //                     {data.StateName}
    //                 </option>
    //             );
    //             setShipStatecmb(State)
    //         }
    //     }
    // }

    useEffect(() => {
        // debugger;
        if (ComboDataResponse !== undefined) {
            setLoading(false);
            if (ComboDataResponse["AccountType"] !== undefined
                && ComboDataResponse["AccountGroup"] !== undefined
                && ComboDataResponse["Industry"] !== undefined
                && ComboDataResponse["Currency"] !== undefined
                && ComboDataResponse["Country"] !== undefined
                // && ComboDataResponse["State"] !== undefined

            ) {
                setLoading(false);
                AccountTypeData(ComboDataResponse["AccountType"]);
                AccountGroupData(ComboDataResponse["AccountGroup"]);
                IndustryData(ComboDataResponse["Industry"]);
                CurrencyData(ComboDataResponse["Currency"]);
                CountryData(ComboDataResponse["Country"]);
                BillStatecmbData("")
                ShipStatecmbData("")

                if (props.AccountID !== '') {
                    BillStatecmbData("")
                    ShipStatecmbData("")
                    setMode('Update');
                    GetAccountData();
                }
                else {
                    setMode('Insert');
                }
            }
        }
    }, [ComboDataResponse]);

    const GetAccountData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("AccountID", props.AccountID);
        setLoading(true);
        fetchData("Account/GetByID", bodyFormData);
    };

    const GetComboData = () => {
        // debugger;
        setLoading(true);
        fetchComboData("Account/ComboData");
    };
    useEffect(() => {
        GetComboData();
    }, [])

    const onCheckChange = (e) => {
        //// debugger;
        setIsChecked(e.target.checked);
        console.log(isChecked);
    };

    const onSelectChange = (e) => {
        // debugger;
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "AccGroupID") {
                setAccGroupID(targetvalue)
            }
            else if (targetname === "AccTypeID") {
                setAccTypeID(targetvalue)
            }
            else if (targetname === "IndustryID") {
                setIndustryID(targetvalue)
            }
            else if (targetname === "BillCountryID") {
                setBillCountryID(targetvalue)
                BillStatecmbData(targetvalue);
            }
            else if (targetname === "BillStateID") {
                setBillStateID(targetvalue)
            }
            else if (targetname === "ShipCountryID") {
                setShipCountryID(targetvalue)
                ShipStatecmbData(targetvalue);
            }
            else if (targetname === "ShipStateID") {
                setShipStateID(targetvalue)
            }
            else if (targetname === "CurrencyID") {
                setCurrencyID(targetvalue)
            }
        }
        else {
            if (targetname === "AccGroupID") {
                setAccGroupID("")
            }
            else if (targetname === "AccTypeID") {
                setAccTypeID("")
            }
            else if (targetname === "IndustryID") {
                setIndustryID("")
            }
            else if (targetname === "BillCountryID") {
                setBillCountryID("");
                setBillStatecmb([]);
            } else if (targetname === "BillStateID") {
                setBillStateID("");
            } else if (targetname === "ShipCountryID") {
                setShipStateID("");
                setShipStateID([]);
            } else if (targetname === "ShipStateID") {
                setShipStateID("");
            }
            else if (targetname === "CurrencyID") {
                setCurrencyID("")
            }
        }
    }
    return (
        <div>
            {/* {
                loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 10,
                    }}>
                        <Loader />
                    </div>
                )
            } */}
            <Formik initialValues={{
                AccountCode: AccountCode, ReferenceCode: ReferenceCode, AccName: AccName, AccTypeID: AccTypeID, AccGroupID: AccGroupID, IndustryID: IndustryID,
                CurrencyID: CurrencyID, WebSite: WebSite, PhoneNo: PhoneNo, NoOfEmp: NoOfEmp, Description: Description, BillAddress1: BillAddress1, ShipAddress1: ShipAddress1,
                BillAddress2: BillAddress2, ShipAddress2: ShipAddress2, BillCity: BillCity, BillStateID: BillStateID, GSTIN: GSTIN, ShipCity: ShipCity, ShipStateID: ShipStateID, BillPINCode: BillPINCode,
                BillCountryID: BillCountryID, ShipPINCode: ShipPINCode, ShipCountryID: ShipCountryID, CIN: CIN,
            }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Typography className={classes.headertext} noWrap>Account Information</Typography>
                        <Grid spacing={1} container direction="row">
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"AccountCode"}
                                    style={{ display: "block", width: "100%" }}
                                >
                                    {"Account Code"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="AccountCode"
                                    disabled={true}
                                    onChange={(e) => setAccountCode(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <label htmlFor={"AccName"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Acount Name"}
                                </label>
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='AccName'
                                    ref={ref}
                                    value={AccName}
                                    onChange={(e) => {
                                        setAccName(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"ReferenceCode"}
                                    style={{ display: "block", width: "100%" }}
                                >
                                    {"Reference Code"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="ReferenceCode"
                                    ref={ref}
                                    value={ReferenceCode}
                                    onChange={(e) => {

                                        setReferenceCode(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <label htmlFor={"AccGroupID"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Account Group"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control='select'
                                    name='AccGroupID'
                                    options={AccGroupcmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <label htmlFor={"AccTypeID"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Account Type"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control='select'
                                    name='AccTypeID'
                                    options={AccTypecmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <label htmlFor={"IndustryID"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Industry"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control='select'
                                    name='IndustryID'
                                    options={Industrycmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <label htmlFor={"CurrencyID"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Currency"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control='select'
                                    name='CurrencyID'
                                    options={Currencycmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <label htmlFor={"PhoneNo"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Phone No"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='PhoneNo'
                                    ref={ref}
                                    value={PhoneNo}
                                    onChange={(e) => {
                                        setPhoneNo(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={2}>
                                    <label htmlFor={"WebSite"}
                                        style={{
                                            display: 'block', width: '100%'
                                        }}>
                                        {"Website"}
                                    </label>
                                </Grid>
                                <Grid item xs={10}>
                                    <BiztranControlsFormik
                                        control='input'
                                        type='text'
                                        name='WebSite'
                                        onChange={(e) => setWebSite(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={2}>
                                    <label htmlFor={"Description"}
                                        style={{
                                            display: 'block', width: '100%'
                                        }}>
                                        {"Description"}
                                    </label>
                                </Grid>
                                <Grid item xs={10}>
                                    <BiztranControlsFormik
                                        control='input'
                                        type='text'
                                        name='Description'
                                        ref={ref}
                                        value={Description}
                                        onChange={(e) => {
                                            setDescription(e.target.value)
                                            handleChange()
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            {/* <Grid item xs={2}>
                                <label htmlFor={"NoOfEmp"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"No Of Employees"}
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    // label='No Of Employees'
                                    name='NoOfEmp'
                                    onChange={(e) => setNoOfEmp(e.target.value)}
                                />
                            </Grid> */}
                        </Grid>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={12}>
                            </Grid>
                            <Grid item xs={12}>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography className={classes.headertext} noWrap>Address Information</Typography>
                            </Grid>
                            <Grid item xs={8} style={{ display: "flex", marginLeft: "50%" }}>
                                <label>Shipping Address Same as Billing Address?</label>
                                <div style={{ paddingLeft: 10 }}>
                                    <input
                                        type="checkbox"
                                        name="chkbox"
                                        checked={isChecked}
                                        onChange={onCheckChange}
                                    ></input>
                                </div>
                            </Grid>
                            {/* <Grid item xs={6} style={{ display: "flex" }}>
                                <label>Billing Address Same as Shipping  Address?</label>
                                <div style={{ paddingLeft: 10 }}>
                                    <input
                                        type="checkbox"
                                        name="chkbox"
                                        checked={isDoubleChecked}
                                        onChange={onDoubleCheckChange}
                                    ></input>
                                </div>
                            </Grid> */}
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='textarea'
                                    type='text'
                                    label='Bill Address1'
                                    name='BillAddress1'
                                    ref={ref}
                                    value={BillAddress1}
                                    onChange={(e) => {
                                        setBillAddress1(e.target.value)
                                        handleChange()
                                    }
                                    }
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='textarea'
                                    type='text'
                                    label='Bill Address2'
                                    name='BillAddress2'
                                    ref={ref}
                                    value={BillAddress2}
                                    onChange={(e) => {
                                        setBillAddress2(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='textarea'
                                    type='text'
                                    label='Ship Address1'
                                    name='ShipAddress1'
                                    ref={ref}
                                    value={ShipAddress1}
                                    onChange={(e) => {
                                        setShipAddress1(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='textarea'
                                    type='text'
                                    label='Ship Address2'
                                    name='ShipAddress2'
                                    ref={ref}
                                    value={ShipAddress2}
                                    onChange={(e) => {
                                        setShipAddress2(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='Bill Country'
                                    name='BillCountryID'
                                    options={BillCountrycmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='Bill State'
                                    name='BillStateID'
                                    options={BillStatecmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='Ship Country'
                                    name='ShipCountryID'
                                    options={ShipCountrycmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='Ship State'
                                    name='ShipStateID'
                                    options={ShipStatecmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>

                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Bill City'
                                    name='BillCity'
                                    ref={ref}
                                    value={BillCity}
                                    onChange={(e) => {
                                        setBillCity(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='input'
                                    type="number"
                                    label='Bill PIN Code'
                                    name='BillPINCode'
                                    ref={ref}
                                    value={BillPINCode}
                                    onChange={(e) => {
                                        setBillPINCode(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>

                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    // autoFocus="autofocus"
                                    control='input'
                                    type='text'
                                    label='Ship City'
                                    name='ShipCity'
                                    ref={ref}
                                    value={ShipCity}
                                    onChange={(e) => {
                                        setShipCity(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='number'
                                    label='Ship PIN Code'
                                    name='ShipPINCode'
                                    ref={ref}
                                    value={ShipPINCode}
                                    onChange={(e) => {
                                        setShipPINCode(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            {/* {BillCountryID == "FA4EFB9C-68D1-419D-899E-7635E19A5758" ? */}
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='GSTIN'
                                    name='GSTIN'
                                    ref={ref}
                                    value={GSTIN}
                                    disabled={DisableGSTIN}
                                    onChange={(e) => {
                                        setGSTIN(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>


                            {/* {BillCountryID === "FA4EFB9C-68D1-419D-899E-7635E19A5758" ? */}
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='CIN'
                                    name='CIN'
                                    ref={ref}
                                    value={CIN}
                                    disabled={DisableCIN}
                                    onChange={(e) => {
                                        setCIN(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            {/* : null
                            } */}
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            disabled={DisableSaveBtn}
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>


                        </Grid>

                    </Form>
                }}
            </Formik>
        </div >
    );
};

const useStyles = makeStyles((theme) => ({
    headertext: {
        background: theme.palette.tertiary.gradient,
        color: "white",
        height: "2rem",
        paddingLeft: "30px",
        fontSize: "1.5rem",
        marginTop: "-16px",
        marginBottom: "10px",
        marginLeft: "-24px",
        marginRight: "-24px",
        //   borderRadius: "1rem",
    },
}));

export default CreateAccount;
